import IComponent from "components/commons/IComponent";
import Button from "@material-ui/core/Button";
import EditableDatagridCell from "components/commons/EditableDatagridCell";
import "./PanelBase.scoped.css";
import "./LastUpdatedDate.scoped.css";
import DivTable from "components/commons/DivTable";

class LastUpdatedDate extends IComponent {
  constructor(props) {
    super(props);

    this.state = {
      MapDate: undefined, //[{ LAYER: "", LAST_UPDATE: "" }],
      isLoading: true,
    };
  }
  componentDidMount() {
    this.getMapDate();
  }
  componentWillUnmount() {}

  async getMapDate() {
    let domain = this.$config.webSrvUrl;
    let Result = JSON.parse(
      await this.makeHttpQuery(
        domain + this.$config.layerupdates,
        "POST",
        "",
        true
      )
    );
    this.setState({ MapDate: Result, isLoading: false });
  }

  render() {
    let { MapDate, isLoading } = this.state;
    return (
      <div>
        <div className="PanelBaseTitle EqualWidthChildren">
          <span>Last Updated Date</span>
          <div />
          <span
            className="icn_3d_Elevationprofile_close CloseButton"
            onClick={() => this.props.mapUICallback("hideAllPanel")}
          />
        </div>

        <div className="PanelContent">
          <div style={{ height: `${this.props.currentDialogHeight}px` }}>
            <DivTable
              data={MapDate}
              columnDef={[
                {
                  name: "Layer",
                  value: "LAYER",
                },
                {
                  name: "Last Updated Date",
                  value: "LAST_UPDATE",
                },
              ]}
              noDataText={function() {
                if (isLoading)
                  return (
                    <div className="SubPanelContent">
                      <div>
                        <span className="icn_loading" /> Refreshing your layer
                        and last updated date..
                      </div>
                      <div
                        style={{
                          textAlign: "center",
                          padding: "10px",
                        }}
                      >
                        ***Close the window to cancel process***
                      </div>
                    </div>
                  );
              }.apply(this)}
            />
          </div>
        </div>
      </div>
    );
  }
}

export default LastUpdatedDate;
